import { map } from 'rxjs';
import type { ValueChainView, ValueChainInput } from '../../../core/interfaces/backend/cadenas_valor/cadenas_valor.workflow.interface';
import type { SuccessEnvelope } from '../../../core/interfaces/http/response.interface';
import type { Envelope, Deleted } from '../../../core/interfaces/http/response.interface';
import type { SideData } from '../../../core/interfaces/http/pagination.interface';
import type { CadenasValorRead, CadenasValorCreate, CadenasValorReplace, CadenasValorPatch, CadenasValorIdentifier, CadenasValorDeleteAll } from '../../../core/interfaces/backend/cadenas_valor/cadenas_valor.interface';

import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class CadenasValor {
  private readonly http = inject(HttpClient);
  private readonly url = environment.backendUrl.replace(/\/$/, '') + '/pvt/gb/cadenas_valor';
  sideQuery(page = 1, row = 20, sort: keyof CadenasValorRead = 'id_registro', direction: 'asc' | 'desc' = 'asc',
    filters: Partial<CadenasValorRead> = {}, headers?: HttpHeaders): Observable<HttpResponse<Envelope<SideData<CadenasValorRead>>>> {
    return this.http.get<Envelope<SideData<CadenasValorRead>>>(this.url + '/side/query', {
      observe: 'response', headers,
      params: { page, row, sort, direction, filters: JSON.stringify(filters) },
    });
  }
  selectAll(headers?: HttpHeaders): Observable<HttpResponse<Envelope<CadenasValorRead[]>>> {
    return this.http.get<Envelope<CadenasValorRead[]>>(this.url + '/select/all', {
      observe: 'response',
      headers,
    });
  }
  selectReg(
    id_registro: string,
    headers?: HttpHeaders,
  ): Observable<HttpResponse<Envelope<CadenasValorRead>>> {
    return this.http.get<Envelope<CadenasValorRead>>(this.url + '/select/reg', {
      observe: 'response',
      headers,
      params: { id_registro },
    });
  }
  selectPgt(
    sheet = 1,
    row = 20,
    headers?: HttpHeaders,
  ): Observable<HttpResponse<Envelope<CadenasValorRead[]>>> {
    return this.http.get<Envelope<CadenasValorRead[]>>(this.url + '/select/pgt', {
      observe: 'response',
      headers,
      params: { sheet, row },
    });
  }
  insertRegister(
    body: CadenasValorCreate,
    headers?: HttpHeaders,
  ): Observable<HttpResponse<Envelope<CadenasValorRead>>> {
    return this.http.post<Envelope<CadenasValorRead>>(this.url + '/insert/register', body, {
      observe: 'response',
      headers,
    });
  }
  insertMultiple(
    body: CadenasValorCreate[],
    headers?: HttpHeaders,
  ): Observable<HttpResponse<Envelope<CadenasValorRead[]>>> {
    return this.http.post<Envelope<CadenasValorRead[]>>(this.url + '/insert/multiple', body, {
      observe: 'response',
      headers,
    });
  }
  replaceRegister(
    body: CadenasValorReplace,
    headers?: HttpHeaders,
  ): Observable<HttpResponse<Envelope<CadenasValorRead>>> {
    return this.http.put<Envelope<CadenasValorRead>>(this.url + '/update/register', body, {
      observe: 'response',
      headers,
    });
  }
  replaceMultiple(
    body: CadenasValorReplace[],
    headers?: HttpHeaders,
  ): Observable<HttpResponse<Envelope<CadenasValorRead[]>>> {
    return this.http.put<Envelope<CadenasValorRead[]>>(this.url + '/update/multiple', body, {
      observe: 'response',
      headers,
    });
  }
  patchRegister(
    body: CadenasValorPatch,
    headers?: HttpHeaders,
  ): Observable<HttpResponse<Envelope<CadenasValorRead>>> {
    return this.http.patch<Envelope<CadenasValorRead>>(this.url + '/update/register', body, {
      observe: 'response',
      headers,
    });
  }
  patchMultiple(
    body: CadenasValorPatch[],
    headers?: HttpHeaders,
  ): Observable<HttpResponse<Envelope<CadenasValorRead[]>>> {
    return this.http.patch<Envelope<CadenasValorRead[]>>(this.url + '/update/multiple', body, {
      observe: 'response',
      headers,
    });
  }
  deleteRegister(
    body: CadenasValorIdentifier,
    headers?: HttpHeaders,
  ): Observable<HttpResponse<Envelope<Deleted>>> {
    return this.http.delete<Envelope<Deleted>>(this.url + '/delete/register', {
      observe: 'response',
      headers,
      body,
    });
  }
  deleteMultiple(
    body: CadenasValorIdentifier[],
    headers?: HttpHeaders,
  ): Observable<HttpResponse<Envelope<Deleted>>> {
    return this.http.delete<Envelope<Deleted>>(this.url + '/delete/multiple', {
      observe: 'response',
      headers,
      body,
    });
  }
  deleteAll(
    body: CadenasValorDeleteAll,
    headers?: HttpHeaders,
  ): Observable<HttpResponse<Envelope<Deleted>>> {
    return this.http.delete<Envelope<Deleted>>(this.url + '/delete/all', {
      observe: 'response',
      headers,
      body,
    });
  }

  viewProject(projectId:string) {
    return this.http.get<SuccessEnvelope<ValueChainView>>(this.url + '/project/' + projectId).pipe(map(r => r.data));
  }
  saveProject(projectId:string, body:ValueChainInput) {
    return this.http.post<SuccessEnvelope<ValueChainView>>(this.url + '/project/' + projectId, body).pipe(map(r => r.data));
  }
  downloadProjectFile(projectId:string, fileId:string) {
    return this.http.get(this.url + '/project/' + projectId + '/files/' + fileId, {responseType:'blob'});
  }
}
